<!-- Page Container -->
<div class="flex min-h-screen items-center justify-center bg-white py-20">
  <div class="flex flex-col">
    <div class="col-span-6 grid place-content-center bg-white px-4">
      <div class="w-64 h-52 -ml-16 bg-logo-light bg-no-repeat dark:bg-logo-dark" alt=""></div>
    </div>
    <!-- Error Container -->
    <div class="flex flex-col items-center">
      <div class="text-9xl font-bold text-primary-500">404</div>

      <div class="mt-10 text-center text-3xl font-bold md:text-5xl lg:text-5xl xl:text-5xl">
        La página que buscas, <br />no se encuentra disponible
      </div>

      <div class="lg:text-1xl mt-8 text-sm font-medium text-gray-400 md:text-xl">
        <a href="/" class="text-primary-500 hover:underline">
          <span class="text-primary-500 hover:underline">
            Volver a la pagina principal
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
